import LandingQuotes from 'components/LandingQuotes/LandingQuotes'

export default LandingQuotes
